import { useLinkRelValue } from "hooks";
import { Link as ChakraLink } from "@chakra-ui/react";
import type { SbEditableComponentProps } from "types/storyblok";
import { useLanguage } from "contexts/LocalizationContext";
import type { LinkProps } from "./Link.d";
import { getResolvedDefaultHref } from "./utils";

const Link = ({ text, href, isExternal = false, sbEditable }: SbEditableComponentProps<LinkProps>) => {
  const relValue = useLinkRelValue(href);
  const language = useLanguage();
  const link = getResolvedDefaultHref(href, language);

  return (
    <ChakraLink rel={relValue} href={link} isExternal={isExternal} fontSize="md" _visited={{}} {...sbEditable}>
      {text}
    </ChakraLink>
  );
};

export default Link;
